import { render, staticRenderFns } from "./UserBrand.vue?vue&type=template&id=bede4952&scoped=true"
import script from "./UserBrand.vue?vue&type=script&lang=js"
export * from "./UserBrand.vue?vue&type=script&lang=js"
import style0 from "./UserBrand.vue?vue&type=style&index=0&id=bede4952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bede4952",
  null
  
)

export default component.exports